import { useNode } from '@craftjs/core';
import {
	NumberControl,
	TextControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';

const EditorBaseImageSettings = () => {
	const {
		alt,
		width,
		height,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onAltChange, onWidthChange, onHeightChange] = useMemo(
		() =>
			['alt', 'width', 'height'].map((attr) => generateOnChange(setProp, attr)),
		[setProp]
	);

	return (
		<div>
			<TextControl
				value={alt}
				label={intl.tr('screenEditor.settings.image.alt')}
				setValue={onAltChange}
			/>
			<NumberControl
				min={1}
				value={width}
				label={intl.tr('screenEditor.settings.image.width')}
				setValue={onWidthChange}
				placeholder={
					height > 0
						? intl.tr('screenEditor.settings.image.autoSizePlaceholder')
						: intl.tr('screenEditor.settings.image.originalSizePlaceholder')
				}
			/>
			<NumberControl
				min={1}
				value={height}
				label={intl.tr('screenEditor.settings.image.height')}
				setValue={onHeightChange}
				placeholder={
					width > 0
						? intl.tr('screenEditor.settings.image.autoSizePlaceholder')
						: intl.tr('screenEditor.settings.image.originalSizePlaceholder')
				}
			/>
		</div>
	);
};

export { EditorBaseImageSettings };
